import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Div from '../Page/Div';
import { sanitize } from '../../utils';
const LegalsSection = ({ content, idx, allowOpen }) => {
    const { title, content: legalContent } = content?.legals ?? {};
    return (_jsxs("div", { className: "legals-container", children: [_jsx(Div, { className: "legals-title", delay: 0, noScale: true, children: _jsx("div", { className: "legals-title-wrapper", children: title }) }), _jsx(Div, { className: "legals-text", delay: 1, noScale: true, children: _jsx("div", { className: "legals-content", children: _jsx("div", { className: "legals-content-wrapper", dangerouslySetInnerHTML: {
                            __html: sanitize(legalContent),
                        } }) }) })] }));
};
export default LegalsSection;
